import { startCase } from 'lodash-es';
import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Exhibit } from './styled.jsx';
import { Sel, STagNew } from '#~/stag/index.js';

const toExhibitPath = (category: string): string => `/exhibits/${category}`;

/** Exhibit `<Manifest>` component. */
export const Manifest = (): ReactElement => (
  <Exhibit title='Exhibits'>
    <div className='flex flex-col items-center gap-16'>
      {[
        'audio',
        'tags',
        'buttons',
        'dials',
        'gamepad',
        'hot-keys',
        'icons',
        'inputs',
        'notification-stack',
        'notifications',
        'posthog',
        'selects',
        'sliders',
        'steppers',
        'switches',
        'tabs',
        'toggles',
        'video-badges',
        'wheel',
        'invite-by-link',
        'monitoring'
      ].map((category) => (
        <Link
          key={category}
          to={toExhibitPath(category)}
          {...STagNew(Sel.Exhibits, 'link', category)}
        >
          {startCase(category)}
        </Link>
      ))}
    </div>
  </Exhibit>
);
